module.exports = __webpack_public_path__ + "static/media/close-grey.80d0ae7f.svg";